export const medium = {
    block: 'container--mg align--center',
    inner: 'align--center'
};
export const large = {
    ...medium,
    block: 'container--lg align--center',
    inner: 'container--mg align--center'
};
export const small = {
    ...medium,
    block: 'container--sg align--center'
};
export const activitiesClassNames = {
    ...large,
    content: 'teaser--default'
};
export const gridClassNamesLarge = {
    ...large,
    block: '',
    inner: 'container--lg align--center'
};
export const gridItemsNames = {
    ...large,
    block: 'col-xs-12 col-sm-6 col-md-3'
};
export const componentsClassNames = {
    jumbotron: {
        inner: 'container--mg align--center'
    },
    pager: {
        navigationButton: 'button button--primary'
    }
};
export const pagesClassNames = {
    newsDetailPage: {
        jumboType: 'small',
        jumboContent: 'date',
        introInner: 'container--sg align--center'
    },
    newsOverview: {
        inner: 'container--lg align--center'
    }
};
export const defaultClassNames = {
    activities_selection_block: medium,
    activity_cluster: activitiesClassNames,
    book: medium,
    books: large,
    caroussel: large,
    collection_group: medium,
    collection_item: medium,
    collection_search_bar: medium,
    collection: large,
    content_grid_item: medium,
    content_grid_video: medium,
    content_grid: large,
    core_activity_cluster: medium,
    cta_block: medium,
    datetime: medium,
    expander_item: medium,
    expanders: medium,
    faq_collection: medium,
    featured_content: medium,
    formstack_block: medium,
    grid_block: gridClassNamesLarge,
    grid_items: gridItemsNames,
    highlight: small,
    iframe: medium,
    images: medium,
    inline_media: medium,
    jumbotron: componentsClassNames.jumbotron,
    knop: medium,
    location: medium,
    media: medium,
    newsDetailPage: pagesClassNames.newsDetailPage,
    newsletter_signup_form: medium,
    newsOverview: pagesClassNames.newsOverview,
    opening_hours: medium,
    page_grid: medium,
    pager: componentsClassNames.pager,
    panorama: medium,
    quote: small,
    recent_news: large,
    submenu_item: medium,
    submenu: medium,
    subscription_block: medium,
    subscriptions: medium,
    text: small,
    themakiezer_embed: medium,
    tipped_activities_block: medium,
    vacancy_overview: medium,
    wordcloud_block: medium
};
